import React from 'react';
import { Routes, Route } from "react-router-dom";

import Landing from './../../pages/landing';

import AuthRoute from './../../components/routes/auth-route';
import Login from './../../pages/auth/login';
import ForgotPassword from './../../pages/auth/forgot-password';
import RegistrationRoute from './../../components/routes/registration-route';

import ProtectedRoute from './../../components/routes/protected-route';
import InnerRoute from './inner-route';

import Unauthorized from '../../pages/admin/unauthorized';

import Admin from './../../pages/admin';
import Registration from './../../pages/auth/registration';

import AccountSettings from '../../pages/admin/settings/account';
import CompanySettings from '../../pages/admin/settings/company';
import GeneralSettings from '../../pages/admin/settings/general';
import ManageUsers from '../../pages/admin/settings/manage-users';
import Reminders from '../../pages/admin/settings/reminders';
import HelpSupport from '../../pages/admin/settings/help-support';

import Dashboard from './../../pages/admin/dashboard';
import Bookings from './../../pages/admin/bookings';
import CreateBooking from './../../pages/admin/bookings/create-booking';
import BookingDetails from '../../pages/admin/bookings/booking-details';
import Invoices from '../../pages/admin/bookings/invoices';
import InvoiceDetails from '../../pages/admin/bookings/invoices/invoice-details';
import Properties from './../../pages/admin/properties';
import PropertyDetails from './../../pages/admin/properties/details-property';
import Parties from './../../pages/admin/party';
import AddParty from './../../pages/admin/party/add-party';
import EditParty from './../../pages/admin/party/edit-party';
import PartyDetails from './../../pages/admin/party/party-details';
import Receipts from './../../pages/admin/receipts';
import ReceiptDetails from './../../pages/admin/receipts/receipt-details';
import Notifications from './../../pages/admin/notifications';
import Associates from '../../pages/admin/associates';
import AddAssociates from '../../pages/admin/associates/add-associate';
import AssociatesDetails from '../../pages/admin/associates/associate-details';
import EditAssociates from '../../pages/admin/associates/edit-associate';
import Ledger from '../../pages/admin/ledger';
import Transactions from "../../pages/admin/ledger/transactions";
import Expenses from '../../pages/admin/expenses';
import Leads from '../../pages/admin/leads';
import LeadDetails from '../../pages/admin/leads/lead-details';

const Router = () => {
  return (
    <Routes>
      <Route path='/' element={<AuthRoute><Landing /></AuthRoute>} />
      <Route path='/login' element={<AuthRoute><Login /></AuthRoute>} />
      <Route path='/forgot-password' element={<AuthRoute><ForgotPassword /></AuthRoute>} />
      <Route path='/setup-profile' element={<RegistrationRoute><Registration /></RegistrationRoute>} />

      <Route path='/admin' element={<ProtectedRoute allowedRoles={["admin", "manager", "employee"]}> <Admin /> </ProtectedRoute>}>
        <Route path='/admin/dashboard' element={<Dashboard />} />

        <Route path='/admin/leads' element={<InnerRoute />} >
          <Route path='/admin/leads' element={<Leads />} />
          <Route path='/admin/leads/details/:leadID' element={<LeadDetails />} />
        </Route>

        <Route path='/admin/bookings' element={<InnerRoute />}>
          <Route path='/admin/bookings' element={<Bookings />} />
          <Route path='/admin/bookings/create' element={<CreateBooking />} />
          <Route path='/admin/bookings/details' element={<BookingDetails />} />
          <Route path='/admin/bookings/invoices' element={<Invoices />} />
          <Route path='/admin/bookings/invoices/:invoiceID' element={<InvoiceDetails />} />
        </Route>

        <Route path='/admin/properties' element={<InnerRoute />} >
          <Route path='/admin/properties' element={<Properties />} />
          <Route path='/admin/properties/details' element={<PropertyDetails />} />
        </Route>

        <Route path='/admin/parties' element={<InnerRoute />} >
          <Route path='/admin/parties' element={<Parties />} />
          <Route path='/admin/parties/add' element={<AddParty />} />
          <Route path='/admin/parties/details' element={<PartyDetails />} />
          <Route path='/admin/parties/edit' element={<EditParty />} />
        </Route>

        <Route path='/admin/associates' element={<InnerRoute />} >
          <Route path='/admin/associates' element={<Associates />} />
          <Route path='/admin/associates/add' element={<AddAssociates />} />
          <Route path='/admin/associates/details' element={<AssociatesDetails />} />
          <Route path='/admin/associates/edit' element={<EditAssociates />} />
        </Route>

        <Route path='/admin/receipts' element={<InnerRoute />}>
          <Route path='/admin/receipts' element={<Receipts />} />
          <Route path='/admin/receipts/:id' element={<ReceiptDetails />} />
        </Route>
        <Route path='/admin/ledger' element={<InnerRoute />}>
          <Route path='/admin/ledger' element={<Ledger />} />
          <Route path='/admin/ledger/:id' element={<Transactions />} />
        </Route>
        <Route element={<InnerRoute />}>
          <Route path='/admin/expenses' element={<Expenses />} />
        </Route>
        <Route path='/admin/notifications' element={<Notifications />} />
        <Route path='/admin/settings' element={<InnerRoute />}>
          <Route path='/admin/settings/account' element={<AccountSettings />} />
          <Route path='/admin/settings/company' element={<CompanySettings />} />
          <Route path='/admin/settings/general' element={<GeneralSettings />} />
          <Route path='/admin/settings/manage-users' element={<ManageUsers />} />
          <Route path='/admin/settings/reminders' element={<Reminders />} />
          <Route path='/admin/settings/help-support' element={<HelpSupport />} />
        </Route>
      </Route>
      <Route path='*' element={Unauthorized} />
    </Routes>
  );
}

export default Router;
